import { ComponentFactoryResolver, DOCUMENT } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { IconWrapperModule } from 'Angular/features/components/icon-wrapper/icon-wrapper.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { KeyStatsModalModule } from 'CalculationsApp/ts/features/key-stats-modal/key-stats-modal.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { StocksEditProfileModalButtonModule } from 'CompanyApp/ts/features/stocks-edit-profile-modal-button/stocks-edit-profile-modal-button.module';
import { IconWrapperComponent } from 'Angular/features/components/icon-wrapper/icon-wrapper.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { KeyStatsModalComponent } from 'CalculationsApp/ts/features/key-stats-modal/components/key-stats-modal/key-stats-modal.component';
import { GeneralChartResponsiveComponent } from 'ChartApp/ts/features/general-chart/components/general-chart-responsive/general-chart-responsive.component';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { StocksEditProfileModalButtonComponent } from 'CompanyApp/ts/features/stocks-edit-profile-modal-button/stocks-edit-profile-modal-button.component';
import { PublicSecurityHeaderComponent } from 'SecuritiesApp/ts/features/public-security-header/public-security-header.component';
import { getLogger } from 'Angular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
/**
 * Public Quote Page
 *
 * Smaller bundle for logged-out quote pages of every type. Imports only the modules behind the roots
 * those pages host; bootstraps by host presence, so a type without charts or key stats is unaffected.
 */
// Every <ycn-*> host the anonymous quote templates render, across all security types
const entryComponents = [
    GeneralChartResponsiveComponent,
    IconWrapperComponent,
    KeyStatsModalComponent,
    PieChartComponent,
    PublicSecurityHeaderComponent,
    StocksEditProfileModalButtonComponent,
    TopBarNavComponent,
];
export class PublicQuotePageModule extends DoVariableBootstrap {
    constructor(document, componentFactoryResolver) {
        super(document, componentFactoryResolver, entryComponents);
        // Roots the templates may render more than once per page
        this.nonSingularComponents = [
            GeneralChartResponsiveComponent,
            IconWrapperComponent,
            PieChartComponent,
            StocksEditProfileModalButtonComponent,
        ];
    }
}
PublicQuotePageModule.ɵfac = function PublicQuotePageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PublicQuotePageModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
PublicQuotePageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PublicQuotePageModule });
PublicQuotePageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        GeneralChartModule,
        IconWrapperModule,
        KeyStatsModalModule,
        NavigationModule,
        PieChartModule,
        PublicSecurityHeaderComponent,
        StocksEditProfileModalButtonModule,
        // The top bar autocomplete and the key stats modal keep their state in the store
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
